import PlaylistData from "../playlist/data/PlaylistData";
import { sortBy } from "../helper/orderBy";

export class PlaylistIndexLoader {
  public ofCrew(
    playlists: ReadonlyArray<PlaylistData>,
    currentCrewIdentifier: string | undefined,
  ): ReadonlyArray<PlaylistData> {
    return playlists.filter(
      (playlist) => playlist.belongsToCrew === currentCrewIdentifier,
    );
  }

  public orderBy(
    playlistIndex: ReadonlyArray<PlaylistData>,
    field: keyof PlaylistData,
    ascOrDesc: "asc" | "desc",
  ): ReadonlyArray<PlaylistData> {
    console.debug(
      "Order playlist index by newField=" +
        field +
        " newAscOrDesc=" +
        ascOrDesc,
    );
    return sortBy(playlistIndex, field, ascOrDesc);
  }
}
